import React from "react";
import classnames from "classnames";

export function DonationButton({ amt, donationAmt, isMonthly, setDonationAmt }) {

  return (
    <div className="control is-flex-grow-1">
      <button
        className={classnames("button has-text-weight-semibold is-fullwidth", amt === donationAmt ? "has-background-info has-text-white": "has-background-info-light has-text-info")}
        onClick={() => {
          setDonationAmt(amt);
        }}
      >
        {isMonthly ? `$${amt}/mo` : `$${amt * 12}`}
      </button>
    </div>
  );
}

export function DonationButtonsMobile ({donationAmts, donationAmt, setDonationAmt, isMonthly}) {

  return (
    <div>
      <div className="field is-grouped is-mobile is-align-content-center is-justify-content-center mx-6">
        {donationAmts.slice(0, 2).map((amt, i) => (
          <DonationButton key={i} amt={amt} donationAmt={donationAmt} isMonthly={isMonthly} setDonationAmt={setDonationAmt} />
        ))}
      </div>

      <div className="field is-grouped is-mobile is-align-content-center is-justify-content-center mx-6">
        {donationAmts.slice(2, 4).map((amt, i) => (
          <DonationButton key={i} amt={amt} donationAmt={donationAmt} isMonthly={isMonthly} setDonationAmt={setDonationAmt} />
        ))}
      </div>
    </div>
  );
}

export function DonationButtonsNotMobile ({donationAmts, donationAmt, setDonationAmt, isMonthly}) {

    return (
        <div>
            <div className="field is-grouped is-mobile is-align-content-center is-justify-content-center mx-6">
                {donationAmts.map((amt, i) => (
                    <DonationButton key={i} amt={amt} donationAmt={donationAmt} isMonthly={isMonthly} setDonationAmt={setDonationAmt} />
                ))}
            </div>
        </div>
    );
  }